import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import {
  type GetVendorListResponseInterface,
  type VendorListInterface,
  type VendorListPaginatioInterface,
  type VendorRequestType,
  type VendorRequestResponseInterface,
  type VendorRequestParamsType,
  type VendorPaginationType,
} from 'features/Enterprise/Vendor/services/vendorList'

interface InitialStateType {
  isLoading: boolean
  vendorList: VendorListInterface[]
  pagination: VendorListPaginatioInterface
  query: VendorRequestParamsType
  vendorRequestList: VendorRequestType[]
  approvalCount: number
  draftCount: number
  principalCount: number
  vendorCount: number
  submissionPagination: VendorPaginationType
}

export const initialQuery = {
  page_size: '10',
  page_index: 1,
  vendor_name: '',
  status: '',
  approval_pic: '',
  company_name: '',
  category_vendor: '',
  request_pic: '',
  source_type: '',
  cursor: '',
}

const initialState: InitialStateType = {
  isLoading: false,
  vendorList: [],
  pagination: {} as VendorListPaginatioInterface,
  query: initialQuery,
  vendorRequestList: [],
  approvalCount: 0,
  draftCount: 0,
  principalCount: 0,
  vendorCount: 0,
  submissionPagination: {} as VendorPaginationType,
}

export const sliceName = 'vendorList'

export const vendorListSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setVendorList: (state, action: PayloadAction<GetVendorListResponseInterface>) => {
      state.vendorList = action.payload.data
      state.pagination = action.payload.pagination
    },
    setQuery: (state, action: PayloadAction<VendorRequestParamsType>) => {
      state.query = action.payload
    },
    setResetQuery: (state) => {
      state.query = initialState.query
    },
    setVendorRequestList: (state, action: PayloadAction<VendorRequestResponseInterface>) => {
      state.vendorRequestList = action.payload.data
      state.submissionPagination = action.payload.pagination
    },
    setVendorRequestCount: (state, action: PayloadAction<{ status: string; count: number }>) => {
      if (action?.payload?.status === 'DRAFT') {
        state.draftCount = action?.payload?.count
      } else {
        state.approvalCount = action?.payload?.count
      }
    },
    setPrincipalCount: (state, action: PayloadAction<number>) => {
      state.principalCount = action.payload
    },
    setVendorCount: (state, action: PayloadAction<number>) => {
      state.vendorCount = action.payload
    },
    setVendorActiveStatus: (
      state,
      action: PayloadAction<{ vendor_id: number; active: boolean }>,
    ) => {
      const { vendor_id, active } = action.payload
      const vendor = state.vendorList.map((vendor) =>
        vendor.id === vendor_id ? { ...vendor, active } : vendor,
      )
      state.vendorList = vendor
    },
  },
})

export const {
  setLoading,
  setVendorList,
  setQuery,
  setVendorRequestList,
  setVendorRequestCount,
  setResetQuery,
  setVendorActiveStatus,
  setPrincipalCount,
  setVendorCount,
} = vendorListSlice.actions

export default vendorListSlice.reducer
